<template>
    <div class="recovery-page row">
        <PopupWindow
            v-if="isVisiblePopup"
            :key="modal"
            :header="modal.header"
            :info="modal.info"
            :buttonText="modal.button"
            :callback="modal.callback"
            :color="modal.color"
        ></PopupWindow>

        <div class="recovery-page__image col-xl-4 d-none d-xl-block">
            <img src="../assets/IMGS/PNG/03_Oldies.png" alt="grandmother and grandfather" />
        </div>

        <div class="recovery-page__form col-12 offset-xl-2 col-xl-6">
            <div class="row g-4 recovery-page__auth">
                <template v-if="user.recoveryStatus === 0 || user.recoveryStatus === 1">
                    <div>
                        <div>
                            <CInput
                                v-model="user.email"
                                type="text"
                                :validationFunction="tools.validateEmail"
                                ref="email_recovery"
                                id="email_recover"
                                name="email_recover"
                                label="Ваша электронная почта"
                                required
                            />
                        </div>
                    </div>

                    <div v-if="user.recoveryStatus === 0">
                        <div
                            v-on:click="sendCode()"
                            class="ui-button ui-button--lg ui-button--primary"
                            :class="{ blocked: !user.email }"
                        >
                            Отправить код
                        </div>
                    </div>

                    <template v-if="user.recoveryStatus === 1">
                        <div>
                            <div class="row align-items-center">
                                <div class="col">
                                    <CInput
                                        v-model="user.code"
                                        type="text"
                                        ref="code_recovery"
                                        id="code_recovery"
                                        name="code_recovery"
                                        label="Код"
                                        placeholder="0000000000"
                                        required
                                    />
                                </div>
                                <div class="col-auto">
                                    <div
                                        v-on:click="sendCode()"
                                        class="ui-button ui-button--sm ui-button--primary"
                                    >
                                        Отправить код заново
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <p id="wrong_code" class="recovery-page__error"></p>
                            </div>
                        </div>

                        <div class="">
                            <div class="">
                                <div
                                    id="button_sumbit"
                                    @click="recoveryAccount"
                                    class="ui-button ui-button--lg ui-button--secondary"
                                    :class="{ blocked: !user.code }"
                                >
                                    Подтвердить
                                </div>
                            </div>
                        </div>
                    </template>
                </template>

                <template v-if="user.recoveryStatus === 2">
                    <div>
                        <div>
                            <CInput
                                v-model="user.password"
                                type="password"
                                ref="password"
                                id="password"
                                name="password"
                                label="Пароль"
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <div>
                            <CInput
                                v-model="user.passwordRepeat"
                                type="password"
                                ref="password_repeated"
                                id="password_repeated"
                                name="password_repeated"
                                label="Пароль (повторно)"
                                required
                            />
                        </div>
                        <div>
                            <p id="password_error" class="recovery-page__error"></p>
                        </div>
                    </div>

                    <div class="">
                        <div
                            id="button_sumbit"
                            v-on:click="setNewPassword()"
                            class="ui-button ui-button--lg ui-button--secondary"
                            :class="{ blocked: !user.password && !user.passwordRepeat }"
                        >
                            Подтвердить
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import popup from './ModalComponent.vue';
import CInput from './InputComponent.vue';
import tools from '../assets/js/tools';

export default {
    name: 'RecoveryPage',
    el: '#recoveryPage',
    components: {
        PopupWindow: popup,
        CInput,
    },
    data() {
        return {
            modal: {
                header: 'Подтверждение',
                info: '',
                button: '',
                color: '#0ECCAA',
            },
            isVisiblePopup: false,
            user: {
                email: null,
                recoveryStatus: 0,
                code: null,
                password: null,
                passwordRepeat: null,
                buttonBlocked: true,
            },

            formStatus: [],
            tools: tools,
        };
    },

    methods: {
        sendCode() {
            var vm = this;
            if (!vm.user.email) {
                return;
            }
            var actionUrl = global.BACKEND_URL + '/account/forgot_password/' + vm.user.email;
            $.ajax({
                type: 'POST',
                url: actionUrl,
                data: vm.user,
                success: function () {
                    vm.modal = {
                        header: 'Подтверждение',
                        info: 'Код отправлен на указанную почту!',
                        button: 'Дальше',
                        color: '#0ECCAA',
                    };
                    vm.isVisiblePopup = true;
                    vm.user.recoveryStatus = 1;
                    vm.user.code = null;
                },
                error: function (data) {
                    vm.modal = {
                        header: 'Ошибка',
                        info: 'Данная почта не используется!',
                        button: 'Дальше',
                        color: '#0ECCAA',
                    };
                    vm.isVisiblePopup = true;
                    console.log('Not success :( #', data);
                },
                dataType: 'text',
                contentType: 'application/json',
            });
        },

        recoveryAccount() {
            document.getElementById('wrong_code').innerHTML = '';
            var vm = this;
            var actionUrl = global.BACKEND_URL + '/account/forgot_password/' + vm.user.email + '/' + vm.user.code;
            if (vm.user.code) {
                $.ajax({
                    type: 'POST',
                    url: actionUrl,
                    data: vm.user,
                    success: function () {
                        (vm.modal = {
                            header: 'Информация',
                            info: 'Код верный, идем дальше!',
                            button: 'ОК',
                            color: '#0ECCAA',
                        }),
                            (vm.isVisiblePopup = true);
                        vm.user.recoveryStatus = 2;
                    },
                    error: function (data) {
                        console.log('Not success :( #', data);
                        document.getElementById('wrong_code').innerHTML = 'Код неверный!';
                    },
                    dataType: 'text',
                    contentType: 'application/json',
                });
            }
        },

        setNewPassword() {
            var vm = this;
            if (!vm.user.password && !vm.user.passwordRepeat) {
                return;
            }
            var actionUrl =
                global.BACKEND_URL +
                '/account/forgot_password/' +
                vm.user.email +
                '/' +
                vm.user.code +
                '/' +
                vm.user.password;
            if (vm.user.password == vm.user.passwordRepeat) {
                /*sumbit new pass*/
                $.ajax({
                    type: 'POST',
                    url: actionUrl,
                    data: vm.user.password,
                    success: function (data) {
                        console.log(data);
                        (vm.modal = {
                            header: 'Информация',
                            info: 'Вы установили новый пароль!',
                            button: 'ОК',
                            color: '#0ECCAA',
                            callback: function () {
                                window.location.href = '/authorization';
                            },
                        }),
                            (vm.isVisiblePopup = true);
                    },
                    error: function (data) {
                        console.log('Not success :( #' + data);
                    },
                    dataType: 'text',
                    contentType: 'application/json',
                });
            } else {
                /*not sumbit new pass*/
                document.getElementById('password_error').innerHTML = 'Пароли не совпадают!';
            }
        },
    },
};
</script>
<style lang="css" scoped src="@/assets/css/dispatcher_orders.css"></style>

<style lang="scss">
.recovery-page {
    &__error {
        color: #ee6870;
        font-size: 16px;
        line-height: 18px;
    }
}
</style>
